'use client'
import React from 'react'
import NavigationViewLink from '@/services/components/strategies/navigation/NavigationViewLink/NavigationViewLink'
import { getEventService } from '@/services/events/EventInstance'
import { AreaItem } from '@/types/cms/AreaItem'

interface NavigationViewLinkStateProps {
  item: AreaItem
}

const NavigationViewLinkState: React.FC<NavigationViewLinkStateProps> = ({
  item,
}) => {
  const handleClick = () => {
    getEventService().emit('navigate-menu', item)
  }

  return <NavigationViewLink item={item} onNavigate={handleClick} />
}

export default NavigationViewLinkState
